import { render, staticRenderFns } from "./FacturacionExpiroLink.vue?vue&type=template&id=4f06c4eb&scoped=true"
import script from "./FacturacionExpiroLink.vue?vue&type=script&lang=js"
export * from "./FacturacionExpiroLink.vue?vue&type=script&lang=js"
import style0 from "./FacturacionExpiroLink.vue?vue&type=style&index=0&id=4f06c4eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06c4eb",
  null
  
)

export default component.exports